






























































import Vue from 'vue';
import { required } from 'vuelidate/lib/validators';
import { FormValidation } from '@/mixins';
import BeneficiaryListing from '@/components/account-components/beneficiary-components/beneficiary-listing.component.vue';
import { ExtendMixins } from '@/services';
import { PRIMARY_BENEFICIARY, CONTINGENT_BENEFICIARY } from '@/constants';
import { AccountBeneficiaryResponseModel, MemberAccountResponseModel } from '@/@types/member';

interface Data {
  termsAndConditions: boolean;
}

export default ExtendMixins(
  FormValidation,
).extend({
  name: 'BeneficiariesReview',
  props: {
    accountId: {
      type: [String, Number],
      required: true,
    },
    beneficiaries: {
      type: Array as () => AccountBeneficiaryResponseModel[],
      required: true,
    },
    reviewMode: {
      type: Boolean,
      default: false,
    },
    hasPendingChanges: {
      type: Boolean,
      default: false,
    },
    hasPrimaryBeneficiaries: {
      type: Boolean,
      default: false,
    },
  },
  data(): Data {
    return {
      termsAndConditions: false,
    };
  },
  beforeMount() {
    this.showErrorModel.termsAndConditions = false;
  },
  computed: {
    account(): MemberAccountResponseModel {
      return this.$store.getters.currentAccount(this.accountId);
    },
    isHSA(): boolean {
      return this.account.productType === 'HSA';
    },
    isVEBA(): boolean {
      return this.account.productType === 'VEBA';
    },
    termsAndConditionsLabel(): string {
      if (this.isHSA) {
        return this.$options.filters.t([
          'beneficiaries_form-label_terms-and-conditions_hsa',
        ]);
      } else if (this.isVEBA) {
        return this.$options.filters.t([
          'beneficiaries_form-label_terms-and-conditions_veba',
        ]);
      }
    },
    primaryBeneficiaries(): AccountBeneficiaryResponseModel[] {
      if (this.beneficiaries) {
        return this.beneficiaries.filter((beneficiary) => {
          return beneficiary.type === PRIMARY_BENEFICIARY;
        });
      }
      return [];
    },
    secondaryBeneficiaries(): AccountBeneficiaryResponseModel[] {
      if (this.beneficiaries) {
        return this.beneficiaries.filter((beneficiary) => {
          return beneficiary.type === CONTINGENT_BENEFICIARY;
        });
      }
      return [];
    },
    showPrimarySharePercentageWarning(): boolean {
      const total = this.primaryBeneficiaries.reduce(
        (totalPercentage, beneficiary) => {
          return totalPercentage + parseInt(beneficiary.sharePercentage as any);
        },
        0,
      );
      return !!(
        this.primaryBeneficiaries.length &&
        total !== 100 &&
        total !== 0
      );
    },
    showSecondarySharePercentageWarning(): boolean {
      const total = this.secondaryBeneficiaries.reduce(
        (totalPercentage, beneficiary) => {
          return totalPercentage + parseInt(beneficiary.sharePercentage as any);
        },
        0,
      );
      return !!(
        this.secondaryBeneficiaries.length &&
        total !== 100 &&
        total !== 0
      );
    },
    disableSave() {
      /*
        *   Disable if:
        *   - there are no changes
        *   - there are warnings
        */
      return (
        // @ts-ignore
        !this.hasPendingChanges ||
        !!(
          this.showPrimarySharePercentageWarning ||
          this.showSecondarySharePercentageWarning
        )
      );
    },

    //      VALIDATIONS
    termsAndConditionsErrors(): string[] {
      const formField = 'termsAndConditions';
      return this.FormValidationMixin.constructErrors(formField, [
        this.FormValidationMixin.validateField(
          formField,
          [
            'beneficiaries_form-error_terms-and-conditions_required',
            'global_form-error_terms-and-conditions_required',
            'global_form-error_default_required',
          ],
          'required',
        ),
      ]);
    },
  },
  validations: {
    termsAndConditions: {
      required,
    },
  },
  methods: {
    editBeneficiary(beneficiary): void {
      this.$emit('editBeneficiary', beneficiary);
    },
    removeBeneficiary(beneficiary): void {
      this.$emit('removeBeneficiary', beneficiary);
    },
  },
  components: {
    BeneficiaryListing,
  },
});
